import { MaintenancePlanCodeCreate } from "@boark/shared/types/maintenance-plan-code-create";
import { MaintenancePlanCode } from "@boark/shared/types/maintenance-plan-code";
import { maintenancePlanCodeSchema } from "@boark/shared/types/maintenance-plan-code";

import { deleteRequest, postRequest } from "../utils/request";
import { recordIdToId } from "../utils/record-id-to-id";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function createMaintenancePlanCode(
  maintenancePlanCode: MaintenancePlanCodeCreate,
): Promise<MaintenancePlanCode> {
  return postRequest(
    `${API_BASE_URL}/maintenance-plan-code`,
    {
      code: maintenancePlanCode.code,
      maintenancePlanGroup: maintenancePlanCode.maintenancePlanGroup.startsWith(
        "maintenancePlanGroup:",
      )
        ? recordIdToId(maintenancePlanCode.maintenancePlanGroup)
        : maintenancePlanCode.maintenancePlanGroup,
    },
    maintenancePlanCodeSchema,
  );
}

export async function deleteMaintenancePlanCode(id: string): Promise<void> {
  return deleteRequest(`${API_BASE_URL}/maintenance-plan-code/${id}`);
}
